export default "__VITE_ASSET__BaZXz_mh__"